import React, { useContext } from 'react';
import { keepPreviousData } from '@tanstack/react-query';
import RegistrationCompositeDetailContent from '@/components/features/RegistrationCompositeDetail';
import { SegmentationContext } from '@/contexts/SegmentationContext';
import { AccountId, RegistrationCompositeId } from '@/generated/data.schemas';
import { useGetRegistrationComposite } from '@/generated/registration-composite';
import { useGetTranslations } from '@/generated/translations';
import Head, { PageMetadata } from './_head.partial';
import Page from './_page.partial';


interface RegistrationCompositeDetailProps {
	accountId: AccountId;
	registrationCompositeId: RegistrationCompositeId;
}

const RegistrationCompositeDetail: React.FC<RegistrationCompositeDetailProps> = (props) => {
	const { accountId, registrationCompositeId } = props;
	const { segmentationId } = useContext(SegmentationContext);
	const { data: translations } = useGetTranslations(segmentationId);
	const pageMetaData = translations?.data.applications.pageMetaData;
	const { data: response } = useGetRegistrationComposite(segmentationId, accountId, registrationCompositeId, {
		query: {
			placeholderData: keepPreviousData,
		},
	});

	const setMetaData = (): PageMetadata => {
		return {
			title: response?.data.applicationName || pageMetaData?.title || '',
			description: pageMetaData?.description || '',
			keywords: '',
			noIndex: true,
			noFollow: true,
		};
	};

	return (
		<Page hasNoContentSpacer hideCustomerSelector>
			<Head metaData={setMetaData()} />

			<RegistrationCompositeDetailContent
				accountId={accountId}
				registrationCompositeId={registrationCompositeId}
				application={response?.data}
			/>
		</Page>
	);
};

export default RegistrationCompositeDetail;
